<h3>Added by: {{ (practiceChange.user | resolveUser).email }}</h3>

<rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
  <div class="inputs">
    <div class="row">
      <div class="col-4">
        <mat-form-field appearance="fill" floatLabel="always" class="w-100">
          <mat-label>Date</mat-label>
          <input matInput [ngxMatDatetimePicker]="picker" placeholder="Choose a date" [(ngModel)]="practiceChange.date" rsValid="required">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="false">
          </ngx-mat-datetime-picker>
        </mat-form-field>

        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
          <mat-label>Activity</mat-label>
          <mat-select [(ngModel)]="practiceChange.activity" rsValid="required" [placeholder]="(dataService.practiceChangeActivities | async)?.length === 0 ? 'No risks found' : ''">
            <mat-option *ngFor="let activity of dataService.practiceChangeActivities | async" [value]="activity.id">{{ activity.name }} - {{ (activity.category | resolveCategory).name }}</mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>
  </div>

  <!--  <div class="inputs">-->
  <!--    <div class="row">-->
  <!--      <div class="col-4">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Risk Addressed</mat-label>-->
  <!--          <mat-select [(ngModel)]="assistance.riskAddressed" rsValid="required" [placeholder]="(filteredRisks | async)?.length === 0 ? 'No risks found' : ''">-->
  <!--            <mat-option *ngFor="let risk of filteredRisks | async" [value]="risk.id">{{ risk.name }} - {{ (risk.category | resolveCategory).name }}</mat-option>-->
  <!--          </mat-select>-->
  <!--        </mat-form-field>-->
  <!--      </div>-->

  <!--      <div class="col-4">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Plan Activity</mat-label>-->
  <!--          <mat-select [(ngModel)]="assistance.planActivity" rsValid="required">-->
  <!--            <mat-option *ngFor="let planActivity of (dataService.localDefinitions | async)?.actionPlans" [value]="planActivity.id">{{ planActivity.name }}</mat-option>-->
  <!--          </mat-select>-->
  <!--        </mat-form-field>-->
  <!--      </div>-->

  <!--      <div class="col-2">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Learnt New Skills</mat-label>-->
  <!--          <mat-slide-toggle-->
  <!--            [(ngModel)]="assistance.learntNewSkills"-->
  <!--            style="user-select: none;"-->
  <!--          >-->
  <!--            <ng-container *ngIf="assistance.learntNewSkills">Yes-->
  <!--              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>-->
  <!--            </ng-container>-->
  <!--            <ng-container *ngIf="!assistance.learntNewSkills">No</ng-container>-->
  <!--          </mat-slide-toggle>-->
  <!--          <textarea matInput hidden style="display: none !important;"></textarea>-->
  <!--        </mat-form-field>-->
  <!--      </div>-->

  <!--      <div class="col-2">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Intent to Change</mat-label>-->
  <!--          <mat-slide-toggle-->
  <!--            [(ngModel)]="assistance.intentToChange"-->
  <!--            style="user-select: none;"-->
  <!--          >-->
  <!--            <ng-container *ngIf="assistance.intentToChange">Yes-->
  <!--              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>-->
  <!--            </ng-container>-->
  <!--            <ng-container *ngIf="!assistance.intentToChange">No</ng-container>-->
  <!--          </mat-slide-toggle>-->
  <!--          <textarea matInput hidden style="display: none !important;"></textarea>-->
  <!--        </mat-form-field>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->

  <!--  <div class="inputs">-->
  <!--    <div class="row">-->
  <!--      <div class="col-2">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Practice Change</mat-label>-->
  <!--          <mat-slide-toggle-->
  <!--            [(ngModel)]="assistance.practiceChange"-->
  <!--            style="user-select: none;"-->
  <!--          >-->
  <!--            <ng-container *ngIf="assistance.practiceChange">Yes-->
  <!--              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>-->
  <!--            </ng-container>-->
  <!--            <ng-container *ngIf="!assistance.practiceChange">No</ng-container>-->
  <!--          </mat-slide-toggle>-->
  <!--          <textarea matInput hidden style="display: none !important;"></textarea>-->
  <!--        </mat-form-field>-->
  <!--      </div>-->

  <!--      <div class="col-2">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Grant Applied For</mat-label>-->
  <!--          <mat-slide-toggle-->
  <!--            [(ngModel)]="assistance.grantAppliedFor"-->
  <!--            style="user-select: none;"-->
  <!--          >-->
  <!--            <ng-container *ngIf="assistance.grantAppliedFor">Yes-->
  <!--              <mat-icon style="vertical-align: middle;" color="primary">check</mat-icon>-->
  <!--            </ng-container>-->
  <!--            <ng-container *ngIf="!assistance.grantAppliedFor">No</ng-container>-->
  <!--          </mat-slide-toggle>-->
  <!--          <textarea matInput hidden style="display: none !important;"></textarea>-->
  <!--        </mat-form-field>-->
  <!--      </div>-->

  <!--      <div class="col-4">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Grant Name</mat-label>-->
  <!--          <input matInput [(ngModel)]="assistance.grantAppliedForName" placeholder="Grant Name" [disabled]="assistance.grantAppliedFor === false"  />-->
  <!--        </mat-form-field>-->
  <!--      </div>-->

  <!--      <div class="col-4">-->
  <!--        <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">-->
  <!--          <mat-label>Referral for Additional Support</mat-label>-->
  <!--          <mat-select [(ngModel)]="assistance.referralForAdditionalSupport" rsValid="required">-->
  <!--            <mat-option *ngFor="let additionalSupport of (dataService.localDefinitions | async)?.additionalSupport" [value]="additionalSupport.id">{{ additionalSupport.name }}</mat-option>-->
  <!--          </mat-select>-->
  <!--        </mat-form-field>-->
  <!--      </div>-->

  <!--    </div>-->
  <!--  </div>-->

  <div class="inputs">
    <div class="input full">
      <mat-form-field [floatLabel]="'always'" appearance="fill" class="w-100">
        <mat-label>Notes</mat-label>
        <input matInput [(ngModel)]="practiceChange.notes" placeholder="Notes"/>
      </mat-form-field>
    </div>
  </div>
</rsValidForm>


<br/>
<ng-template #actionButtons>

  <button mat-button (click)="cancel()">
    Cancel
  </button>

  <button color="primary" mat-button (click)="savePracticeChange()">
    <mat-icon>save</mat-icon>
    Save
  </button>

</ng-template>
